// Directorio de puestos (56 registros) generado desde el Excel de direcciones
// del cliente (DIRECCIONES PROYECTOS ACT.). Coordenadas resueltas desde los
// enlaces de Google Maps. Dataset estatico embebido: primera version independiente
// para la presentacion; a futuro se reemplaza por un endpoint enlazado al puesto real.

export const CLIENTES_COLOR = {
    "DOLE": "#1e88e5",
    "PRONACA": "#e53935",
    "PSA MARINE": "#8e24aa",
    "PRECISAGRO": "#43a047",
    "TECNOVA": "#fb8c00",
    "ADILISA": "#6d4c41",
    "JETFEEDER": "#00897b"
};

export const PUESTOS_DIRECTORIO = [
    {
        "id": 1,
        "cliente": "DOLE",
        "grupo": "NAPORTEC Y PATIOS INTERNOS Y EXTERNOS",
        "puesto": "NAPORTEC",
        "direccion": "AV. 52 Y AV.DE LOS ANGELES VIA PERIMETRAL- GUAYAQUIL",
        "referencia": "INGRESANDO POR UPC # 22 DE ISLA TRINITARIA",
        "responsable": "DIEGO SINCHIGUANO",
        "lat": -2.252981,
        "lng": -79.926431,
        "link": "https://maps.app.goo.gl/rHWCVSZY3WXGsrhb6",
        "color": "#1e88e5"
    },
    {
        "id": 2,
        "cliente": "DOLE",
        "grupo": "NAPORTEC Y PATIOS INTERNOS Y EXTERNOS",
        "puesto": "PATIO R8",
        "direccion": "AV. 52 Y AV.DE LOS ANGELES VIA PERIMETRAL-GUAYAQUIL",
        "referencia": "DIAGONAL DERECHA PUERTO NAPORTEC",
        "responsable": "DIEGO SINCHIGUANO",
        "lat": -2.2497015,
        "lng": -79.9237822,
        "link": "https://maps.app.goo.gl/t3iZSeQ4BcXmttWv6",
        "color": "#1e88e5"
    },
    {
        "id": 3,
        "cliente": "DOLE",
        "grupo": "NAPORTEC Y PATIOS INTERNOS Y EXTERNOS",
        "puesto": "PATIO R9",
        "direccion": "KM. 23 VÍA PERÍMETRAL Y AV. DR. MARCEL LANIADO DE WIND-GUAYAQUIL",
        "referencia": "DIAGONAL A HOSPITAL UNIVERSITARIO Y MERCADO MAYORISTA MONTEBELLO",
        "responsable": "DIEGO SINCHIGUANO",
        "lat": -2.0927944,
        "lng": -79.9484402,
        "link": "https://maps.app.goo.gl/a2LkYQgpBvuameoP9",
        "color": "#1e88e5"
    },
    {
        "id": 4,
        "cliente": "DOLE",
        "grupo": "NAPORTEC Y PATIOS INTERNOS Y EXTERNOS",
        "puesto": "PATIO R10",
        "direccion": "KM. 23 VÍA PERÍMETRAL Y AV. DR. MARCEL LANIADO DE WIND-GUAYAQUIL",
        "referencia": "DIAGONAL A HOSPITAL UNIVERSITARIO Y MERCADO MAYORISTA MONTEBELLO",
        "responsable": "DIEGO SINCHIGUANO",
        "lat": -2.0913791,
        "lng": -79.9491201,
        "link": "https://maps.app.goo.gl/BaDtaXj1cTJd9qi28",
        "color": "#1e88e5"
    },
    {
        "id": 5,
        "cliente": "DOLE",
        "grupo": "NAPORTEC Y PATIOS INTERNOS Y EXTERNOS",
        "puesto": "PATIO R 11",
        "direccion": "KM. 23 VÍA PERÍMETRAL Y AV. DR. MARCEL LANIADO DE WIND",
        "referencia": "FRENTE AL HOSPITAL UNIVERSITARIO",
        "responsable": "DIEGO SINCHIGUANO",
        "lat": -2.0970123,
        "lng": -79.9497234,
        "link": "https://maps.app.goo.gl/74t1F7PgvnfYCRLx9",
        "color": "#1e88e5"
    },
    {
        "id": 6,
        "cliente": "DOLE",
        "grupo": "NAPORTEC Y PATIOS INTERNOS Y EXTERNOS",
        "puesto": "BODEGA ALMACEN GUAYAS",
        "direccion": "KM. 6.5 DURÁN - TAMBO, FRENTE A PROCARSA (BODEGAS DOLE)",
        "referencia": "DIAGONAL A BODEGAS PROCARSA Y ETIFLEX.",
        "responsable": "DIEGO SINCHIGUANO",
        "lat": -2.2053889,
        "lng": -79.8123889,
        "link": "https://maps.app.goo.gl/ZYhUb6URUNi7nH1t9",
        "color": "#1e88e5"
    },
    {
        "id": 7,
        "cliente": "DOLE",
        "grupo": "NAPORTEC Y PATIOS INTERNOS Y EXTERNOS",
        "puesto": "ESCUELA PAÍS AMAZÓNICO",
        "direccion": "cantón Coronel Marcelino Maridueña, parroquia Coronel Marcelino Maridueña (San Carlos)",
        "referencia": "INGRESANDO FRENTE A UPC PAYO, PASANDO BILLAR 3 HERMANOS Y RANCHO \"HOLGUITA\"",
        "responsable": "DIEGO SINCHIGUANO",
        "lat": -2.259024,
        "lng": -79.5088151,
        "link": "https://maps.app.goo.gl/TyRziRo1XJcCLZgY8",
        "color": "#1e88e5"
    },
    {
        "id": 8,
        "cliente": "DOLE",
        "grupo": "NAPORTEC Y PATIOS INTERNOS Y EXTERNOS",
        "puesto": "OFICINA ZONA GUAYAS",
        "direccion": "KM. 10 VIRGEN DEL FÁTIMA - EL TRIUNFO (SECTOR PUENTE PAYO)",
        "referencia": "ANTES DE LLEGAR A UPC PAYO, INGRESANDO A MANO DERECHA",
        "responsable": "DIEGO SINCHIGUANO",
        "lat": -2.2581667,
        "lng": -79.5611667,
        "link": "https://maps.app.goo.gl/6mzWszK849GgRta2A",
        "color": "#1e88e5"
    },
    {
        "id": 9,
        "cliente": "DOLE",
        "grupo": "NAPORTEC Y PATIOS INTERNOS Y EXTERNOS",
        "puesto": "PATIO SECO - ACOPIO ZONA GUAYAS",
        "direccion": "KM. 10 VIRGEN DEL FÁTIMA - EL TRIUNFO (SECTOR PUENTE PAYO)",
        "referencia": "ANTES DE LLEGAR A UPC PAYO, INGRESANDO A MANO DERECHA",
        "responsable": "DIEGO SINCHIGUANO",
        "lat": -2.2588611,
        "lng": -79.5638611,
        "link": "https://maps.app.goo.gl/oGG7jR4FzjP5aU5e6",
        "color": "#1e88e5"
    },
    {
        "id": 10,
        "cliente": "DOLE",
        "grupo": "FINCAS PROPIAS - ZONA 1",
        "puesto": "ELBAS",
        "direccion": "Via Panamericana kilometro 16 via Babahoyo San Juan, entrando por cuatro varas klm 3 en el recinto la victoria.",
        "referencia": "RECINTO LA VICTORIA PERTENECIENTE A LA PARROQUIA PIMOCHA, FRENTE AL BILLAR LA 17.",
        "responsable": "SUP. ZONA 1 CARNERO",
        "lat": -1.693822,
        "lng": -79.569817,
        "link": "https://maps.app.goo.gl/UDGMtPuqs8eXGPxZ8",
        "color": "#1e88e5"
    },
    {
        "id": 11,
        "cliente": "DOLE",
        "grupo": "FINCAS PROPIAS - ZONA 1",
        "puesto": "JOSEFA",
        "direccion": "Via Panamericana kilometro 16 via Babahoyo San Juan, entrando por cuatro varas kilometro 4 en el recinto la Paz.",
        "referencia": "RECINTO LA PAZ PERTENECIENTE A LA PARROQUIA PIMOCHA",
        "responsable": "SUP. ZONA 1 CARNERO",
        "lat": -1.701888,
        "lng": -79.589825,
        "link": "https://maps.app.goo.gl/4mMrXEsMy1WHHSo27",
        "color": "#1e88e5"
    },
    {
        "id": 12,
        "cliente": "DOLE",
        "grupo": "FINCAS PROPIAS - ZONA 1",
        "puesto": "LOLAS",
        "direccion": "Via Panamericana kilometro 16 via Babahoyo San Juan, entrando por cuatro varas kilometro 6 en el recinto la Paz.",
        "referencia": "RECINTO LA PAZ PERTENECIENTE A LA PARROQUIA PIMOCHA",
        "responsable": "SUP. ZONA 1 CARNERO",
        "lat": -1.701888,
        "lng": -79.589825,
        "link": "https://maps.app.goo.gl/qveeQJT7nG4hVKCY7",
        "color": "#1e88e5"
    },
    {
        "id": 13,
        "cliente": "DOLE",
        "grupo": "FINCAS PROPIAS - ZONA 1",
        "puesto": "MARIA JOSE",
        "direccion": "Via Panamericana kilometro 10 via Babahoyo San Juan, sector Santa Rita",
        "referencia": "A 500 METROS DE LA FABRICA PLASTIVIL",
        "responsable": "SUP. ZONA 1 CARNERO",
        "lat": -1.71,
        "lng": -79.5318056,
        "link": "https://maps.app.goo.gl/h1PWGge55qUZpKg18",
        "color": "#1e88e5"
    },
    {
        "id": 14,
        "cliente": "DOLE",
        "grupo": "FINCAS PROPIAS - ZONA 1",
        "puesto": "BANALOLY",
        "direccion": "Via Panamericana kilometro 10 via Babahoyo San Juan, sector Santa Rita",
        "referencia": "A 500 METROS DE LA FABRICA PLASTIVIL",
        "responsable": "SUP. ZONA 1 CARNERO",
        "lat": -1.71,
        "lng": -79.5318056,
        "link": "https://maps.app.goo.gl/8Ae7cGLMT6VoVTDM9",
        "color": "#1e88e5"
    },
    {
        "id": 15,
        "cliente": "DOLE",
        "grupo": "FINCAS PROPIAS - ZONA 1",
        "puesto": "CART- SANTA RITA",
        "direccion": "Via Panamericana kilometro 10 via Babahoyo San Juan, sector Santa Rita",
        "referencia": "A 500 METROS DE LA FABRICA PLASTIVIL",
        "responsable": "SUP. ZONA 1 CARNERO",
        "lat": -1.709989,
        "lng": -79.531804,
        "link": "https://maps.app.goo.gl/98imc2vDi1fvnMSS6",
        "color": "#1e88e5"
    },
    {
        "id": 16,
        "cliente": "DOLE",
        "grupo": "FINCAS PROPIAS - ZONA 1",
        "puesto": "PATIO SECO LOS RIOS",
        "direccion": "Via Panamericana kilometro 10 via Babahoyo San Juan, sector Santa Rita",
        "referencia": "A 500 METROS DE LA FABRICA PLASTIVIL",
        "responsable": "SUP. ZONA 1 CARNERO",
        "lat": -1.709989,
        "lng": -79.531804,
        "link": "https://maps.app.goo.gl/98imc2vDi1fvnMSS6",
        "color": "#1e88e5"
    },
    {
        "id": 17,
        "cliente": "DOLE",
        "grupo": "FINCAS PROPIAS - ZONA 1",
        "puesto": "ESCUELA VICENTE PIEDRAHITA",
        "direccion": "Via Panamericana kilometro 16 via babahoyo San Juan, entrando por cuatro varas kilometro 4 en el recinto la Angela.",
        "referencia": "RECINTO LA ANGELA PERTENECIENTE A LA PARROQUIA PIMOCHA",
        "responsable": "SUP. ZONA 1 CARNERO",
        "lat": -1.7026944,
        "lng": -79.5790556,
        "link": "https://maps.app.goo.gl/H7Yto4vv7KrJsNGc7",
        "color": "#1e88e5"
    },
    {
        "id": 18,
        "cliente": "DOLE",
        "grupo": "FINCAS PROPIAS - ZONA 2",
        "puesto": "FINCA PARAMOUNT - EL CHOBO",
        "direccion": "FINCA DOLE - HCA. PARAMOUNT - GARITA PRINCIPAL (ubicada en el Cantón Milagro parroquia rural Chobo - conecta con el canton Yaguachi.",
        "referencia": "PARROQUIA EL CHOBO , CERCANO IGLESIA CONDOR DE YAGUACHI",
        "responsable": "SUP. ZONA 2 TAPIR",
        "lat": -2.1244603,
        "lng": -79.6574445,
        "link": "https://maps.app.goo.gl/exjXCx2LPV569y34A",
        "color": "#1e88e5"
    },
    {
        "id": 19,
        "cliente": "DOLE",
        "grupo": "FINCAS PROPIAS - ZONA 2",
        "puesto": "FINCA EL MAIZAL",
        "direccion": "FINCA DOLE - EL MAIZAL - GARITA PRINCIPAL PARROQUIA FUMISA VIA (RECINTO SAGRADA FAMILIA)",
        "referencia": "DETRÁS DE CENTRO DE REVISIÓN VEHICULAR DEL GAD LATACUNGA",
        "responsable": "SUP. ZONA 2 TAPIR",
        "lat": -0.9757715,
        "lng": -78.5869379,
        "link": "https://maps.app.goo.gl/Hx9sU4UPCS1UiW6B6",
        "color": "#1e88e5"
    },
    {
        "id": 20,
        "cliente": "DOLE",
        "grupo": "FINCAS PROPIAS - ZONA 2",
        "puesto": "FINCA ISABEL MARÍA",
        "direccion": "FINCAS DOLE - HDA. ISABEL MARIA - GARITA (PARROQUIA SAN JUAN KM 6)",
        "referencia": "PARROQUIA SAN JUAN, LOS RIOS. DETRÁS DE RECINTO BOLA DE ORO",
        "responsable": "SUP. ZONA 2 TAPIR",
        "lat": -1.65284,
        "lng": -79.537769,
        "link": "https://maps.app.goo.gl/4mTquQhcwMPUHA8u9",
        "color": "#1e88e5"
    },
    {
        "id": 21,
        "cliente": "DOLE",
        "grupo": "FINCAS PROPIAS - ZONA 2",
        "puesto": "FINCA BLANCA ROSA",
        "direccion": "FINCAS DOLE - HDA. BLANCA ROSA - GARITA (PARROQUIA SAN JUAN KM 7)",
        "referencia": "PARROQUIA SAN JUAN, LOS RIOS. DETRÁS DE RECINTO BOLA DE ORO. DIAGONAL A FINCA ISABEL MARÍA.",
        "responsable": "SUP. ZONA 2 TAPIR",
        "lat": -1.658726,
        "lng": -79.522739,
        "link": "https://maps.app.goo.gl/8wQxbbLHu6MTCwXr8",
        "color": "#1e88e5"
    },
    {
        "id": 22,
        "cliente": "DOLE",
        "grupo": "FINCAS PROPIAS - ZONA 2",
        "puesto": "OFICINAS SAN JUAN",
        "direccion": "PARROQUIA SAN JUAN AVENIDA AURORA ESTRADA FRENTE A GASOLINERA TERPEL (PARROQUIA SAN JUAN)",
        "referencia": "LOS RIOS, PARROQUIA SAN JUAN, DIAGONAL A GASOLINERA SAN JUAN MASGAS",
        "responsable": "SUP. ZONA 2 TAPIR",
        "lat": -1.6177032,
        "lng": -79.5584607,
        "link": "https://maps.app.goo.gl/aTCc852wR19eozYH7",
        "color": "#1e88e5"
    },
    {
        "id": 23,
        "cliente": "DOLE",
        "grupo": "FINCAS PROPIAS - ZONA 2",
        "puesto": "FINCA ELOISA",
        "direccion": "PARROQUIA CARACOL; LOS RIOS RECINTO LA VALDIVIA",
        "referencia": "PASANDO CANTÓN BABAHOYO, AVANZANDO POR VÍA CARACOL POSTERIOR A VÍA TRONCAL DE LA COSTA. EN LA INTERCEPCION E25 A UNOS 2 KILOMETROS LLEGA A FINCA SAN LUIS, 1 KM MÁS DELANTE ESTA EL LETRERO DOLE FINCA ELOISA",
        "responsable": "SUP. ZONA 2 TAPIR",
        "lat": -1.6874363,
        "lng": -79.5222076,
        "link": "https://maps.app.goo.gl/aAnMrDykKR9cf3iD6",
        "color": "#1e88e5"
    },
    {
        "id": 24,
        "cliente": "DOLE",
        "grupo": "FINCAS PROPIAS - ZONA 2",
        "puesto": "INMOHANSA",
        "direccion": "Av. Pdte. Juan de Dios Martínez Mera y Carlos Julio Arosemena KM 2.5 via Daule",
        "referencia": "GUAYAQUIL, FRENTE A PLAZA AVENTURA Y DETRÁS DEL DIARIO EXTRA. AL FRENTE LA IGUANA",
        "responsable": "SUP. MERCURIO",
        "lat": -2.1735236,
        "lng": -79.9136936,
        "link": "https://maps.app.goo.gl/WcYCUu19XjLgphDb8",
        "color": "#1e88e5"
    },
    {
        "id": 25,
        "cliente": "DOLE",
        "grupo": "FINCAS PROPIAS - ZONA 2",
        "puesto": "RECEPCION LOGBAN - GACELA",
        "direccion": "Av. Pdte. Juan de Dios Martínez Mera y Carlos Julio Arosemena KM 2.5 via Daule",
        "referencia": "GUAYAQUIL, FRENTE A PLAZA AVENTURA Y DETRÁS DEL DIARIO EXTRA. AL FRENTE LA IGUANA",
        "responsable": "SUP. MERCURIO",
        "lat": -2.1735236,
        "lng": -79.9136936,
        "link": "https://maps.app.goo.gl/WcYCUu19XjLgphDb8",
        "color": "#1e88e5"
    },
    {
        "id": 26,
        "cliente": "DOLE",
        "grupo": "FINCAS PROPIAS - ZONA 2",
        "puesto": "RECEPCION BERLIN - CHARLIE",
        "direccion": "Av. Pdte. Juan de Dios Martínez Mera y Carlos Julio Arosemena KM 2.5 via Daule",
        "referencia": "GUAYAQUIL, FRENTE A PLAZA AVENTURA Y DETRÁS DEL DIARIO EXTRA. AL FRENTE LA IGUANA",
        "responsable": "SUP. MERCURIO",
        "lat": -2.1735236,
        "lng": -79.9136936,
        "link": "https://maps.app.goo.gl/WcYCUu19XjLgphDb8",
        "color": "#1e88e5"
    },
    {
        "id": 27,
        "cliente": "DOLE",
        "grupo": "FINCAS PROPIAS - ZONA 2",
        "puesto": "RECEPCION HAMBURGO - DELTA",
        "direccion": "Av. Pdte. Juan de Dios Martínez Mera y Carlos Julio Arosemena KM 2.5 via Daule",
        "referencia": "GUAYAQUIL, FRENTE A PLAZA AVENTURA Y DETRÁS DEL DIARIO EXTRA. AL FRENTE LA IGUANA",
        "responsable": "SUP. MERCURIO",
        "lat": -2.1735236,
        "lng": -79.9136936,
        "link": "https://maps.app.goo.gl/WcYCUu19XjLgphDb8",
        "color": "#1e88e5"
    },
    {
        "id": 28,
        "cliente": "DOLE",
        "grupo": "FINCAS EL CARMEN - ZONA 4",
        "puesto": "FINCA NUEVA ESPERANZA",
        "direccion": "PARROQUIA ESTANCILLA, CANTÓN TOSAGUA, PROVINCIA DE MANABÍ",
        "referencia": "PASANDO BALNEARIO TURÍSTICO, INGRESANDO POR EL PUENTE LA ESTANCILLA",
        "responsable": "SUP. ANIBAL MUÑOZ",
        "lat": -0.8185167,
        "lng": -80.2075102,
        "link": "https://maps.app.goo.gl/6pmWFQQbjccEmSjJ6",
        "color": "#1e88e5"
    },
    {
        "id": 29,
        "cliente": "PSA MARINE",
        "grupo": "PSA MARINE",
        "puesto": "PSA MARINE MATRIZ",
        "direccion": "EDIFICIO THE POINT- PUERTO SANTA ANA -GUAYAQUIL",
        "referencia": "EDIFICIO THE POINT, PISO 29. OIFICINA 2909",
        "responsable": "ING. STEPHEN SHAW",
        "lat": -2.1782689,
        "lng": -79.8760452,
        "link": "https://maps.app.goo.gl/syTh6SFZqf3U6mAXA",
        "color": "#8e24aa"
    },
    {
        "id": 30,
        "cliente": "PSA MARINE",
        "grupo": "PSA MARINE",
        "puesto": "BODEGA PSA MARINE",
        "direccion": "KM 3 VÍA DATA DE POSORJA, GUAYAS, ECUADOR",
        "referencia": "RUTA 489 VIA PLAYAS-DATA-POSORJA, APROXIMADAMENTE POSTERIOR CASA DE PRÁCTICOS",
        "responsable": "ING. STEPHEN SHAW",
        "lat": -2.7151011,
        "lng": -80.313745,
        "link": "https://maps.app.goo.gl/qEQCxTq8TgPvYJ4s6",
        "color": "#8e24aa"
    },
    {
        "id": 31,
        "cliente": "PSA MARINE",
        "grupo": "PSA MARINE",
        "puesto": "LANCHAS PSA MARINE",
        "direccion": "KM 3 VÍA DATA DE POSORJA, GUAYAS, ECUADOR",
        "referencia": "RUTA 489 VIA PLAYAS-DATA-POSORJA, INGRESANDO AL MUELLE DE LOS PRÁCTICOS",
        "responsable": "ING. STEPHEN SHAW",
        "lat": -2.7151011,
        "lng": -80.313745,
        "link": "https://maps.app.goo.gl/qEQCxTq8TgPvYJ4s6",
        "color": "#8e24aa"
    },
    {
        "id": 32,
        "cliente": "PSA MARINE",
        "grupo": "PSA MARINE",
        "puesto": "LANCHAS PSA ABASTECIMIENTO",
        "direccion": "KM 1.5 VÍA AL MORRO POSORJA, GUAYAS, ECUADOR",
        "referencia": "INGRESANDO HACIA LA ZONA DE MUELLE FORTIDEX APROXIMADAMENTE 500 METROS DEL CEMENTERION",
        "responsable": "ING. STEPHEN SHAW",
        "lat": -2.7031477,
        "lng": -80.2436119,
        "link": "https://maps.app.goo.gl/ugH3NaezNxGraSey8",
        "color": "#8e24aa"
    },
    {
        "id": 33,
        "cliente": "PRECISAGRO",
        "grupo": "PRECISAGRO",
        "puesto": "PLANTA PRECISAGRO",
        "direccion": "KM 13.5 VÍA DAULE, GUAYAQUIL, ECUADOR",
        "referencia": "ZONA INDUSTRIAL VIA A DAULE, BAJANDO POR LA OREJA DE LA PERIMETRAL ANTES DE LLEGAR AL TERMINAL DE PASCUALES",
        "responsable": "SUP. JOHNNY MARTINEZ",
        "lat": -2.0807211,
        "lng": -79.9391389,
        "link": "https://maps.app.goo.gl/aEsC11odpUn9RqfU9",
        "color": "#43a047"
    },
    {
        "id": 34,
        "cliente": "PRECISAGRO",
        "grupo": "PRECISAGRO",
        "puesto": "OFICINAS PRECISAGRO",
        "direccion": "KM 2.5 AV LAS MONJAS Y CARLOS JULIO AROSEMENA, GUAYAQUIL",
        "referencia": "COMPLEJO BERLIN, EDIFICIO HAMBURGO, OFICINA 2.1, DETRÁS DEL DIARIO EXTRA",
        "responsable": "SUP. JOHNNY MARTINEZ",
        "lat": -2.1739471,
        "lng": -79.9132415,
        "link": "https://maps.app.goo.gl/z1bTjmyZVnrB3csYA",
        "color": "#43a047"
    },
    {
        "id": 35,
        "cliente": "TECNOVA",
        "grupo": "TECNOVA",
        "puesto": "TECNOVA BOSCH PLANTA",
        "direccion": "KM 16 VIA DAULE, CALLE 30 NO, PASCUALES, GUAYAQUIL",
        "referencia": "PARQUE INDUSTRIAL PASCUALES FRENTE A SUPRAPLAST POSTERIOR A LA EMPRESA INALECSA",
        "responsable": "SUP. JOHNNY MARTINEZ",
        "lat": -2.0590875,
        "lng": -79.951148,
        "link": "https://maps.app.goo.gl/qLPTs4P3qjgGUo5L8",
        "color": "#fb8c00"
    },
    {
        "id": 36,
        "cliente": "TECNOVA",
        "grupo": "TECNOVA",
        "puesto": "TECNOVA LA GARZOTA",
        "direccion": "DR MIGUEL ANGEL JIJON Y AV 2 NE GUILLERMO PAREJA ROLANDO",
        "referencia": "ALADO DE LA GASOLINERA PRIMAX GARZOTA 2, EN EL INTERIOR DE LA PHARMACYS",
        "responsable": "SUP. JOHNNY MARTINEZ",
        "lat": -2.1485198,
        "lng": -79.8923573,
        "link": "https://maps.app.goo.gl/ddaMYGGDkaAD7WQv9",
        "color": "#fb8c00"
    },
    {
        "id": 37,
        "cliente": "TECNOVA",
        "grupo": "TECNOVA",
        "puesto": "TECNOVA PUERTO AZUL",
        "direccion": "KM 11 VIA A LA COSTA, 090112 GUAYAQUIL",
        "referencia": "FRENTE A URB. PUERTO AZUL, INGRESANDO A LA GASOLINERA PRIMAX PUERTO AZUL LOCAL DEL FONDO",
        "responsable": "SUP. JOHNNY MARTINEZ",
        "lat": -2.1832185,
        "lng": -79.9770827,
        "link": "https://maps.app.goo.gl/pJL4LZvEnUxXE8LM9",
        "color": "#fb8c00"
    },
    {
        "id": 38,
        "cliente": "TECNOVA",
        "grupo": "TECNOVA",
        "puesto": "TECNOVA LA JOYA",
        "direccion": "VIAL 1 LA AURORA, DAULE, GUAYAQUIL",
        "referencia": "INGRESANDO VIAL 1, DENTRO DE LA GASOLINERA PRIMAX LA JOYA, ALADO DE TECNICENTRO MAGNA",
        "responsable": "SUP. JOHNNY MARTINEZ",
        "lat": -2.0303235,
        "lng": -79.9050805,
        "link": "https://maps.app.goo.gl/N2Jdwy8u3jxBVuBm7",
        "color": "#fb8c00"
    },
    {
        "id": 39,
        "cliente": "TECNOVA",
        "grupo": "TECNOVA",
        "puesto": "TECNOVA AYACUCHO ALMACEN",
        "direccion": "GRAL LEONIDAS PLAZA 3014-3160 HUANCAVILCA",
        "referencia": "EDIFICIO GESTITRANSPORT SA, ESQUINA PRIMER PISO, FRENTE A HIDROVAC",
        "responsable": "SUP. JOHNNY MARTINEZ",
        "lat": -2.1955014,
        "lng": -79.9037454,
        "link": "https://maps.app.goo.gl/3T2UtvX5xY6mSB2G7",
        "color": "#fb8c00"
    },
    {
        "id": 40,
        "cliente": "TECNOVA",
        "grupo": "TECNOVA",
        "puesto": "TECNOVA HAMBURGO",
        "direccion": "AV PDTE JUAN DE DIOS MARTINEZ MERA 10, 090615 GUAYAQUIL",
        "referencia": "COMPLEJO INMOHANSA, EDIFICIO LOGBAN FRENTE A AVENTURA PLAZA",
        "responsable": "SUP. JOHNNY MARTINEZ",
        "lat": -2.1735236,
        "lng": -79.9136936,
        "link": "https://maps.app.goo.gl/a5e1GbQjUsCTFxSA8",
        "color": "#fb8c00"
    },
    {
        "id": 41,
        "cliente": "ADILISA",
        "grupo": "ADILISA",
        "puesto": "ADILISA",
        "direccion": "KM 11.5 VIA DAULE, MZ 22 SOLAR 2, GUAYAQUIL",
        "referencia": "AV 42 NO GASTÓN THORET JAGER FRENTE A GRUPO PAPELERO GRUPASA PAPELESA",
        "responsable": "SUP. JOHNNY MARTINEZ",
        "lat": -2.1023448,
        "lng": -79.9405734,
        "link": "https://maps.app.goo.gl/w1GfXDxfLXsSPJbU8",
        "color": "#6d4c41"
    },
    {
        "id": 42,
        "cliente": "PRONACA",
        "grupo": "PRONACA Y FINCAS",
        "puesto": "BODEGA ALMABI",
        "direccion": "AVENIDA DEL BOMBERO Y VIA PERIMETRAL",
        "referencia": "LA UNIVERSIDAD DEL PACIFICO",
        "responsable": "SUP. JHONNY MARTINEZ",
        "lat": -2.1820173,
        "lng": -79.9474282,
        "link": "https://maps.app.goo.gl/Wyo1YQkxCpfzLM9BA",
        "color": "#e53935"
    },
    {
        "id": 43,
        "cliente": "PRONACA",
        "grupo": "PRONACA Y FINCAS",
        "puesto": "COMPLEJO INDUSTRIAL DURAN",
        "direccion": "VIA DURAN TAMBO KM 6,5",
        "referencia": "ENTRANDO POR PROCARSA PASANDO BODEGAS TLD, A LADO DE GISIS",
        "responsable": "SUP. JHONNY MARTINEZ",
        "lat": -2.2171113,
        "lng": -79.8237058,
        "link": "https://maps.app.goo.gl/fr2LYxPPHGpC81T38",
        "color": "#e53935"
    },
    {
        "id": 44,
        "cliente": "PRONACA",
        "grupo": "PRONACA Y FINCAS",
        "puesto": "INCUBADORA NACIONAL",
        "direccion": "BLANCA MUÑOZ BAQUERIZO CALLE 1 Y 3",
        "referencia": "AL FRENTE DE CARTIMEX Y POR LA PARTE DE ATRAS LA UNIVERSIDAD LAICA",
        "responsable": "SUP. JHONNY MARTINEZ",
        "lat": -2.1747635,
        "lng": -79.8902258,
        "link": "https://maps.app.goo.gl/A1AwWyDqZUxT7sej6",
        "color": "#e53935"
    },
    {
        "id": 45,
        "cliente": "PRONACA",
        "grupo": "PRONACA Y FINCAS",
        "puesto": "CEDIS PASCUALES",
        "direccion": "KM-16 1/2 VIA DAULE",
        "referencia": "A LADO FABRICA DE COLGATE- AL FRENTE LA GASOINERA PDV",
        "responsable": "SUP. JHONNY MARTINEZ",
        "lat": -2.0611075,
        "lng": -79.9411952,
        "link": "https://maps.app.goo.gl/2bVBedisMNvTZsCQ6",
        "color": "#e53935"
    },
    {
        "id": 46,
        "cliente": "PRONACA",
        "grupo": "PRONACA Y FINCAS",
        "puesto": "CENTRO DE AVES EN PIE DURAN",
        "direccion": "KM 12 1/2 VIA DURAN TAMBO",
        "referencia": "A LADO CAMARONERA Y AL FRENTE VIA DURAN -TAMBO",
        "responsable": "SUP. JHONNY MARTINEZ",
        "lat": -2.2246041,
        "lng": -79.7637313,
        "link": "https://maps.app.goo.gl/jxKN1f1DKP6ecFpN9",
        "color": "#e53935"
    },
    {
        "id": 47,
        "cliente": "PRONACA",
        "grupo": "PRONACA Y FINCAS",
        "puesto": "PRONACA BALZAR- HACIENDA JOSEFINA",
        "direccion": "KM 15 VIA BALZAR- EL EMPALME",
        "referencia": "CALLE BALZAR GUAYAS",
        "responsable": "SUP. JHONNY MARTINEZ",
        "lat": -1.2706457,
        "lng": -79.833601,
        "link": "https://maps.app.goo.gl/CmeES5VMNEP2GcJa7",
        "color": "#e53935"
    },
    {
        "id": 48,
        "cliente": "PRONACA",
        "grupo": "PRONACA Y FINCAS",
        "puesto": "PLUMROSE",
        "direccion": "AVENIDA PEDRO MENENDEZ GUILBERT 090503 GUAYAGUIL",
        "referencia": "BASE NAVAL NORTE MANO DERECHA",
        "responsable": "SUP. JHONNY MARTINEZ",
        "lat": -2.159906,
        "lng": -79.87623,
        "link": "https://maps.app.goo.gl/XM3dEjVHza7BGSp5A",
        "color": "#e53935"
    },
    {
        "id": 49,
        "cliente": "PRONACA",
        "grupo": "PRONACA Y FINCAS",
        "puesto": "PRONCA MONTECRISTI",
        "direccion": "KM 1 1/2 VIA MANTA",
        "referencia": "ESTA AL FRENTE DE LA CERVECERIA NACIONAL A LADO TENEMOS UNA EMBOTELLADORA DANQUIMICA",
        "responsable": "SUP.ANIBAL MUÑOZ- EL CARMEN",
        "lat": -1.0378862,
        "lng": -80.6672828,
        "link": "https://maps.app.goo.gl/aV6SDACxUomE4aQz8",
        "color": "#e53935"
    },
    {
        "id": 50,
        "cliente": "PRONACA",
        "grupo": "PRONACA Y FINCAS",
        "puesto": "GRANJA AVES AGRO",
        "direccion": "KM-23 VIA CUMANDA RECINTO LA MODELO DEL SECTOR LA ISLA",
        "referencia": "ANTENAS DE MOVISTAR",
        "responsable": "SUP. ARMANDO TORRES",
        "lat": -2.211435,
        "lng": -79.2878036,
        "link": "https://maps.app.goo.gl/MxWuasCTxvthfaYy8",
        "color": "#e53935"
    },
    {
        "id": 51,
        "cliente": "PRONACA",
        "grupo": "PRONACA Y FINCAS",
        "puesto": "GRANJA AVES COSTA 4",
        "direccion": "KM-17 VIA BUCAY EL TRIUNFO RECINTO SANTA MARTHA",
        "referencia": "LINDERO CON LA TABAQUERA DE SANTA MARTHA",
        "responsable": "SUP. ARMANDO TORRES",
        "lat": -2.3038394,
        "lng": -79.2233968,
        "link": "https://maps.app.goo.gl/BHVdJtmHNQQsp7NP9",
        "color": "#e53935"
    },
    {
        "id": 52,
        "cliente": "PRONACA",
        "grupo": "PRONACA Y FINCAS",
        "puesto": "GRANJA LA EUROPEA",
        "direccion": "SECTOR PALO ALTO",
        "referencia": "DESDE LA SALIDA DEL TRIUNFO REDONDEL VIA LA HUIGRA LLEGA EL RECINTO EL PIEDRERO DE AHI CONTINUA HASTA LLEGAR EL RECINTO SAN PEDRO, UNOS 2KM MAS ADELANTE HAY UNA GUARDARAYA LADO IZQUIERDO HAY UNA LLANTA AMARILLA POSTRADA DE AHÍ SE INGRESA VA LARGO GRUZA UN RIO Y CONTINUA LARGO HASTA LLEGAR A LA GRANJA",
        "responsable": "SUP. ARMANDO TORRES",
        "lat": -2.3197715,
        "lng": -79.2470683,
        "link": "https://maps.app.goo.gl/PT5WdwZj3AjG5HH59",
        "color": "#e53935"
    },
    {
        "id": 53,
        "cliente": "PRONACA",
        "grupo": "PRONACA Y FINCAS",
        "puesto": "LABORATORIO BUCAY",
        "direccion": "EL TRIUNFO VIA E487 PALLATANGA Cumanda - Bucay",
        "referencia": "COOPERATIVA 19 DE SEPTIENBRE",
        "responsable": "SUP. ARMANDO TORRES",
        "lat": -2.3303099,
        "lng": -79.3368602,
        "link": "https://maps.app.goo.gl/MewqQdWotQmEcTo3A",
        "color": "#e53935"
    },
    {
        "id": 54,
        "cliente": "PRONACA",
        "grupo": "PRONACA Y FINCAS",
        "puesto": "PLANTA DE PROCESO BUCAY",
        "direccion": "VIA E487 PALLATANGA – CUMANDA BUCAY",
        "referencia": "PASANDO EL PUENTE CHANCHAN SALIENDO DE CUMANDA A MANO DERECHA",
        "responsable": "SUP. ARMANDO TORRES",
        "lat": -2.2143661,
        "lng": -79.1392566,
        "link": "https://maps.app.goo.gl/EjC4E8feovbhZm388",
        "color": "#e53935"
    },
    {
        "id": 55,
        "cliente": "PRONACA",
        "grupo": "PRONACA Y FINCAS",
        "puesto": "OFICINA REGIONAL BUCAY",
        "direccion": "AV E488 PAQUISHA ENTRANDO POR CALLEJON A CASCADA PIEDRA BLANCA",
        "referencia": "VIA BUCAY - NARANJITO A MANO DERECHA DEL PARQUE CRISTO REY",
        "responsable": "SUP. ARMANDO TORRES",
        "lat": -2.1985528,
        "lng": -79.1473394,
        "link": "https://maps.app.goo.gl/ouj8vpgscZMAi3H86",
        "color": "#e53935"
    },
    {
        "id": 56,
        "cliente": "PRONACA",
        "grupo": "PRONACA Y FINCAS",
        "puesto": "PLANTAS DE ABONO BUCAY- ABONASA",
        "direccion": "BALBANERA- PALLATANGA- CUMANDA, SANTA MARTHA,",
        "referencia": "GUAYAS EC PASANDO EL ACHIOTE",
        "responsable": "SUP. ARMANDO TORRES",
        "lat": -2.312182,
        "lng": -79.287649,
        "link": "https://maps.app.goo.gl/N1SasEZ4NZv2KUeE6",
        "color": "#e53935"
    },
    {
        "id": 57,
        "cliente": "JETFEEDER",
        "grupo": "JETFEEDER",
        "puesto": "JETFEEDER",
        "direccion": "VÍA SAMBORONDÓN KM. 10.5",
        "referencia": "ENTRADA DIAGONAL FRENTE AL CC RIOCENTRO EL DORADO. ATRÁS DE LA CIUDADELA FUENTES DEL RÍO. INGRESANDO: LAVADORA KRAKEN CAER SERVICE / LIQUI MOLY",
        "responsable": "JHONY MARTÍNEZ",
        "lat": -2.0569398,
        "lng": -79.8722022,
        "link": "https://maps.app.goo.gl/M3fxuzEi1YGkFjD66",
        "color": "#00897b"
    }
];

export default PUESTOS_DIRECTORIO;
